import * as React from 'react';

import type {Href, HrefHook} from 'src/types';

export const defaultSetHref = (
  _newHref: Href | ((oldHref: Href) => Href),
  _replace?: boolean,
): void => undefined;

const defaultHrefContext: HrefHook = ['/', defaultSetHref];

export default React.createContext<HrefHook>(defaultHrefContext);
